/* ==========================================================================
   crocs-header @ 1.1.0 — header fijo y apertura del carrito

   Broadcast fija el header completo agregando .js__header__stuck en cuanto
   scrollY supera el offset de la seccion, o sea casi de inmediato. Eso arrastra
   la barra negra de promociones, que en el diseno debe irse con el scroll.

   Aca el header queda en el flujo normal y solo se fija la barra blanca, y
   recien cuando la barra de beneficios ya salio completa de la pantalla: en ese
   punto la barra blanca ya esta pegada al borde superior, asi que el cambio a
   position: fixed no produce salto.
   ========================================================================== */

(function () {
  'use strict';

  var SELECTOR = '.crocs-header--sticky';

  function setup(header) {
    // Broadcast agregaba esta clase al body desde data-header-sticky, y de ella
    // dependen los offsets de sus elementos pegajosos (collection nav, look,
    // small newsletter). Al no usar su mecanismo hay que reponerla.
    document.body.classList.add('has-header-sticky');

    var benefits = header.querySelector('.crocs-header__benefits');
    var threshold = 0;
    var stuck = false;
    var queued = false;

    function measure() {
      // Sin barra de beneficios el umbral es 0 y se fija desde el primer pixel.
      threshold = benefits ? benefits.offsetHeight : 0;
    }

    function apply() {
      queued = false;
      var shouldStick = window.scrollY >= threshold;

      if (shouldStick !== stuck) {
        stuck = shouldStick;
        header.classList.toggle('is-stuck', stuck);
      }
    }

    function onScroll() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(apply);
    }

    function onResize() {
      measure();
      apply();
    }

    measure();
    apply();

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);
    // El editor de temas re-renderiza la seccion y cambia el alto de la barra.
    document.addEventListener('shopify:section:load', onResize);
  }

  /* ---------- Carrito ----------

     <header-component> de Broadcast arranca asi:

       killDeadLinks(), this.drawerToggleEvent(), this.cartToggleEvent(), ...

     y drawerToggleEvent hace, sin comprobar nada:

       const t = this.querySelector('[data-drawer-toggle]');
       t.addEventListener('click', ...)

     Este header no emite ese gancho --reemplazo el menu mobile de Broadcast por
     el propio-- asi que ahi revienta con un TypeError y la cadena se corta antes
     de cartToggleEvent. El <a data-cart-toggle> se queda sin handler y navega a
     su href, que es /cart: por eso el icono del header abria la pagina del
     carrito en vez del drawer.

     Se ata aca en vez de reponer un [data-drawer-toggle] de adorno: ese gancho
     despacha el evento sobre [data-drawer], el menu mobile de Broadcast, que
     este theme tampoco usa. */

  function bindCart(header) {
    var toggles = header.querySelectorAll('[data-cart-toggle]');
    var i;

    for (i = 0; i < toggles.length; i++) {
      toggles[i].addEventListener('click', onCartToggle);
    }
  }

  function onCartToggle(event) {
    /* El ajuste manda: con el carrito en modo pagina el enlace tiene que
       navegar, que es justo lo que hace su href. */
    if (!window.theme || !window.theme.settings || window.theme.settings.cartType !== 'drawer') return;

    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    event.preventDefault();
    drawer.dispatchEvent(new CustomEvent('theme:cart-drawer:show'));

    if (window.a11y) window.a11y.lastElement = event.currentTarget;
  }

  function init() {
    var headers = document.querySelectorAll(SELECTOR);
    var i;

    for (i = 0; i < headers.length; i++) {
      if (headers[i].dataset.crocsStickyReady) continue;
      headers[i].dataset.crocsStickyReady = 'true';
      setup(headers[i]);
    }

    /* Va sobre la seccion y no sobre .crocs-header--sticky: el gancho del
       carrito existe aunque el header no sea fijo. */
    var roots = document.querySelectorAll('[data-header-wrapper]');
    for (i = 0; i < roots.length; i++) {
      if (roots[i].dataset.crocsCartReady) continue;
      roots[i].dataset.crocsCartReady = 'true';
      bindCart(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
